import React from 'react';
import { TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import type { TenantView } from '../../../services/tenants/tenants.service';
import classes from '../tenants-page.module.scss';

type TenantWoltBlockProps = {
  tenant: TenantView;
  isUpdating: boolean;
  venueDraft: string;
  onVenueDraftChange: (value: string) => void;
  onDisconnect: () => void;
  onSyncMenu: () => void;
};

const formatExpiry = (iso: string | null | undefined): string => {
  if (!iso) {
    return '';
  }
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '' : ` · תוקף עד ${date.toLocaleString('he-IL')}`;
};

// Super-admin Wolt block: venue id draft (saved by שמור הכל), connection status, menu + disconnect.
export const TenantWoltBlock: React.FC<TenantWoltBlockProps> = ({
  tenant,
  isUpdating,
  venueDraft,
  onVenueDraftChange,
  onDisconnect,
  onSyncMenu,
}) => {
  const connected = Boolean(tenant.woltConnected);
  return (
    <div className={classes.woltSlot} data-testid={`tenants-wolt-block-${tenant.id}`}>
      <span className={classes.photoLabel}>וולט</span>
      <div className={classes.settingsGrid}>
        <TextInput
          label="מזהה סניף וולט"
          placeholder="venue id"
          value={venueDraft}
          onChange={(event) => onVenueDraftChange(event.currentTarget.value)}
          data-testid={`tenants-wolt-venue-${tenant.id}`}
        />
      </div>
      <div className={classes.woltActions}>
        <span
          className={connected ? classes.woltStatusConnected : classes.woltStatusDisconnected}
          data-testid={`tenants-wolt-status-${tenant.id}`}
        >
          {connected ? `מחובר${formatExpiry(tenant.woltTokenExpiresAt)}` : 'לא מחובר'}
        </span>
        {connected && (
          <>
            <Button
              variant="save"
              size="sm"
              disabled={isUpdating}
              onClick={onSyncMenu}
              dataTestId={`tenants-wolt-menu-sync-${tenant.id}`}
            >
              סנכרן תפריט
            </Button>
            <Button
              variant="cancel"
              size="sm"
              disabled={isUpdating}
              onClick={onDisconnect}
              dataTestId={`tenants-wolt-disconnect-${tenant.id}`}
            >
              נתק
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
